import { useMatch, useNavigate } from "react-router-dom";

import { Gear } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationIsExpanded } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";

const SETTINGS_PATH = "/personal-settings/sidebar-customization";

const MainNavigationSettingsButton = () => {
  const isSidebarExpanded = useMainNavigationStore(selectNavigationIsExpanded);

  const navigate = useNavigate();
  const { transitionClasses } = useMainNavigationFadeTransition(isSidebarExpanded);

  const handleClick = () => navigate(SETTINGS_PATH);

  const match = useMatch(SETTINGS_PATH);

  return (
    <ButtonIcon
      icon={Gear}
      variant="ghost"
      size="small"
      onPress={handleClick}
      className={transitionClasses}
      active={!!match}
    >
      Sidebar customization
    </ButtonIcon>
  );
};

export default MainNavigationSettingsButton;
